module.exports = __webpack_public_path__ + "static/leadrx-old-ui-288c72e73dc903f71a8eb630bdf998dc.png";